// import React, { useState } from "react";
// import CheckIcon from "@mui/icons-material/Check";
// import { Button } from "@mui/material";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// export default function AgentSubChild({ currentValue, handleSelect,globalNumberSum,passengers }) {
//     console.log("currentValueData",currentValue)
//   const [count, setCount] = useState(currentValue.number);
//   let toastId1 = null;


// const handleDecrement = () => {
//   if (count > 0) {
//     const newCount = count - 1;
//     setCount(newCount);
//     handleSelect(currentValue._id, 1, newCount, currentValue.price); // 👈 includes price
//   }
// };

// const handleIncrement = () => {
//   const newCount = count + 1;
//   setCount(newCount);
//   handleSelect(currentValue._id, 1, newCount, currentValue.price); // 👈 includes price
// };
//   const showToast = () => {
//     toast.info("Please unselect the option to increment/decrement the value.");
//   };


//   return (
//     <div className="row border-bottom align-items-center px-2 exptraOptionMenu">
//       <div className="col-6 exptraOptionMenuCentered">
//         <div>
//         <span className="child-text"> {currentValue?.type}</span>
//         <span className="child-text"> {currentValue?.desc}</span>
//         </div>
       
//         <p className="child-price">{(currentValue?.price).toFixed(2)} &#8364; </p>
//       </div>
      
//       <div className="col-3 d-flex justify-content-evenly align-items-center plusMinus">
//   <div>
//     <span className="pt-2 uroo">{count}</span>
//   </div>
//   <div>
//   <span
//   className={`px-3 py-0 puls-minus-btn-darkblue pointer ${currentValue.flag !== "0" ? "disabled-button" : ""}`}
//   onClick={currentValue.flag === "0" ? handleDecrement : showToast}
//   style={currentValue.flag !== "0" ? { pointerEvents: "auto", opacity: 0.5 } : {}}
// >
//   -
// </span>
// <span
//   className={`px-3 py-0 puls-minus-btn-skyblue pointer ${
//     currentValue.flag !== "0" ||
//     globalNumberSum >= (passengers - 1) ||
//     count >= (passengers - 1)
//       ? "disabled-button"
//       : ""
//   }`}
//   onClick={
//     currentValue.flag === "0" &&
//     globalNumberSum < (passengers - 1) &&
//     count < (passengers - 1)
//       ? handleIncrement
//       : showToast
//   }
//   style={
//     currentValue.flag !== "0" ||
//     globalNumberSum >= (passengers - 1) ||
//     count >= (passengers - 1)
//       ? { pointerEvents: "none", opacity: 0.5 }
//       : {}
//   }
// >
//   +
// </span>
//   </div>
// </div>
     
//     </div>
//   );
// }


import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function AgentSubChild({
  currentValue,
  handleSelect,
  isMaxReached,
  passengers
}) {
  const [count, setCount] = useState(currentValue.number);
  let toastId1 = null;

  useEffect(()=>{
    setCount(0)
  },[passengers])
  const handleDecrement = () => {
    if (count > 0) {
      const newCount = count - 1;
      setCount(newCount);
      handleSelect(currentValue._id, 1, newCount, currentValue.price);
    }
  };

  const handleIncrement = () => {
    const newCount = count + 1;
    setCount(newCount);
    handleSelect(currentValue._id, 1, newCount, currentValue.price);
  };

  const showToast = () => {
    toast.info("Max seat capacity reached or selection disabled.");
  };

  return (
    <div className="row border-bottom align-items-center px-2 exptraOptionMenu">
      <div className="col-6 exptraOptionMenuCentered">
        <div>
          <span className="child-text"> {currentValue?.type}</span>
          <span className="child-text"> {currentValue?.desc}</span>
        </div>
        <p className="child-price">
          {(currentValue?.price).toFixed(2)} &#8364;
        </p>
      </div>

      <div className="col-3 d-flex justify-content-evenly align-items-center plusMinus">
        <div>
          <span className="pt-2 uroo">{count}</span>
        </div>
        <div>
          <span
            className={`px-3 py-0 puls-minus-btn-darkblue pointer ${
              currentValue.flag !== "0" ? "disabled-button" : ""
            }`}
            onClick={
              currentValue.flag === "0" ? handleDecrement : showToast
            }
            style={
              currentValue.flag !== "0"
                ? { pointerEvents: "none", opacity: 0.5 }
                : {}
            }
          >
            -
          </span>

          <span
            className={`px-3 py-0 puls-minus-btn-skyblue pointer ${
              currentValue.flag !== "0" || isMaxReached
                ? "disabled-button"
                : ""
            }`}
            onClick={
              currentValue.flag === "0" && !isMaxReached
                ? handleIncrement
                : showToast
            }
            style={
              currentValue.flag !== "0" || isMaxReached
                ? { pointerEvents: "none", opacity: 0.5 }
                : {}
            }
          >
            +
          </span>
        </div>
      </div>
    </div>
  );
}
